var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65823 0.125977L0.482422 3.75967V9.2102C0.482422 14.252 3.97077 18.9667 8.65823 20.1113C13.3457 18.9667 16.834 14.252 16.834 9.2102V3.75967L8.65823 0.125977ZM8.65823 3.75967C9.38101 3.75967 10.0742 4.04679 10.5853 4.55788C11.0964 5.06897 11.3835 5.76215 11.3835 6.48494C11.3835 7.20772 11.0964 7.9009 10.5853 8.41199C10.0742 8.92308 9.38101 9.2102 8.65823 9.2102C7.93544 9.2102 7.24226 8.92308 6.73117 8.41199C6.22008 7.9009 5.93296 7.20772 5.93296 6.48494C5.93296 5.76215 6.22008 5.06897 6.73117 4.55788C7.24226 4.04679 7.93544 3.75967 8.65823 3.75967ZM13.3184 14.6607C12.2192 16.3413 10.575 17.604 8.65823 18.2218C6.74145 17.604 5.09721 16.3413 3.99802 14.6607C3.68915 14.2065 3.42571 13.7523 3.20769 13.2709C3.20769 11.772 5.66952 10.5456 8.65823 10.5456C11.6469 10.5456 14.1088 11.7447 14.1088 13.2709C13.8907 13.7523 13.6273 14.2065 13.3184 14.6607Z",
    fill: "#EECA30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.2f6c566fe7b9f265cd97a8a8fac1950c.svg";
export { ForwardRef as ReactComponent };